<div class="relationship-form-group" [formGroup]="form">
  <div class="form-group">
    <app-input
      formControlName="name"
      [label]="nameControlLabel"
      [customErrors]="directorFullNameValidatorMsg"
    />
  </div>

  <div class="form-group">
    <app-address-form-group
      [label]="addressControlLabel"
      [formGroup]="form.controls.address"
      [hidden]="hideAddress"
    />
  </div>
</div>
